import createSvgIcon from "./utils/create_icon"

const More = createSvgIcon(<path d="M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="currentColor" />, "More")
export default More
